module.exports = __webpack_public_path__ + "img/Apple_white.821c4dea.svg";